// Backend cart API (logged-in customers only). Guests use cartStorage.js.
// apiClient returns the response envelope { success, message, data }.
import apiClient from './apiClient.js';

export const getCart = () => apiClient.get('/cart');

export const addCartItem = (payload) => apiClient.post('/cart', payload);

export const updateCartItem = (productId, payload) =>
  apiClient.put(`/cart/${productId}`, payload);

export const removeCartItem = (productId) => apiClient.delete(`/cart/${productId}`);

export const clearCart = () => apiClient.delete('/cart');

export const syncCart = (payload) => apiClient.post('/cart/sync', payload);

export const createCartQuote = (payload) => apiClient.post('/cart/quote', payload);
